"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.275 4.918c.784-.632 1.764-1.124 2.884-1.118 1.407.007 2.648.488 3.528 1.492C20.557 6.285 21 7.703 21 9.45c0 2.303-1.237 4.427-2.688 6.14-1.462 1.727-3.22 3.13-4.434 4.001a3.19 3.19 0 0 1-3.75.001c-1.214-.872-2.974-2.274-4.438-4.001C4.24 13.877 3 11.752 3 9.449c0-1.745.442-3.167 1.313-4.161C5.194 4.28 6.438 3.8 7.85 3.8c1.124 0 2.105.487 2.89 1.119.482.388.907.842 1.266 1.305.36-.462.786-.917 1.269-1.306",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=HeartFilledIcon24.js.map